import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "item" }
const _hoisted_2 = {
  key: 0,
  class: "status-container"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { key: 1 }

import { ref, computed } from 'vue';
	import axios from 'axios';
	import functions from '@/use/functions';
	import Spinner from '@/components/shared/Spinner.vue';
	import { AnnualReviewDetails } from '@/models/loans';
	import { AnnualReviewStatusTypes, StatusTypeOption, AnnualReviewStatusOptionsLookup } from '@/types/annual-review';
	import { Roles } from '@/models/permissions';
	import { useRolesAccess } from '@/composables/usePermissionsAccess';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'AnnualReviewStatus',
  props: {
    annualReview: {},
    onReloadAnnualReviewAsync: { type: Function }
  },
  setup(__props: any) {

	const props = __props;

	const { inRole } = useRolesAccess();

	const isSubmitting = ref<boolean>(false);

	const annualReviewStatusId = ref<number>(props.annualReview.annualReviewStatusId);

	const filteredStatuses = computed(() => filteredAnnualReviewStatuses(props.annualReview.annualReviewStatusId));

	const filteredAnnualReviewStatuses = (annualReviewStatusId: AnnualReviewStatusTypes): StatusTypeOption[] => {
		const allowedStatuses = {
			[AnnualReviewStatusTypes.INITIALLY_PASSED]: [
                AnnualReviewStatusTypes.INITIALLY_PASSED,
				AnnualReviewStatusTypes.APPROVED,
				AnnualReviewStatusTypes.DECLINED
			],
			[AnnualReviewStatusTypes.INITIALLY_FAILED]: [
				AnnualReviewStatusTypes.INITIALLY_FAILED,
				AnnualReviewStatusTypes.DECLINED
			]
		};

		const validStatuses = allowedStatuses[annualReviewStatusId] || [annualReviewStatusId];

		return validStatuses.map((status: number) => AnnualReviewStatusOptionsLookup[status]);
	};

	const enableEditableStatus = computed(() => {
		const validStatuses = [AnnualReviewStatusTypes.INITIALLY_PASSED, AnnualReviewStatusTypes.INITIALLY_FAILED];

		var isAdmin = inRole(Roles.Admin);
		var validOptions = filteredStatuses.value.length > 0;

		return isAdmin && validOptions && validStatuses.includes(props.annualReview.annualReviewStatusId);
	});

	async function updateStatusAsync() {
		isSubmitting.value = true;

		try {
			await axios.post(`/api/annualreview/${props.annualReview.id}/status/${annualReviewStatusId.value}`);

			await props.onReloadAnnualReviewAsync();
		} catch {
			functions.openModal({
				title: 'Oops!',
				description: `Failed to update annual review status. Please try again later.`
			});
		} finally {
			isSubmitting.value = false;
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "label" }, "Status", -1)),
    (enableEditableStatus.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (isSubmitting.value)
            ? (_openBlock(), _createBlock(Spinner, {
                key: 0,
                class: "small"
              }))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("select", {
            disabled: isSubmitting.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((annualReviewStatusId).value = $event)),
            onChange: updateStatusAsync
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredStatuses.value, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option.value,
                value: option.value
              }, _toDisplayString(option.name), 9, _hoisted_4))
            }), 128))
          ], 40, _hoisted_3), [
            [_vModelSelect, annualReviewStatusId.value]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", {
            class: _normalizeClass(['value', __props.annualReview.annualReviewStatusClass])
          }, _toDisplayString(__props.annualReview.annualReviewStatusHumanized), 3)
        ]))
  ]))
}
}

})